var _circle, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPicWhatIsWill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#E4F6FD"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "pic-what-is-will_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F0F7EC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pic-what-is-will_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 27.5,
    width: 59,
    height: 76,
    rx: 4.5,
    stroke: "#12B886",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4155BC",
    strokeWidth: 3,
    d: "M33 42.5h34m-34 9h34m-34 9h34m-34 9h34m-34 9h34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.491 77.054l15-15 3 3-15 15h-3v-3z",
    fill: "#4155BC"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNTAiIGZpbGw9IiNFNEY2RkQiLz48bWFzayBpZD0id2hiIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+PGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNTAiIGZpbGw9IiNGMEY3RUMiLz48L21hc2s+PGcgbWFzaz0idXJsKCN3aGIpIj48cmVjdCB4PSIyMC41IiB5PSIyNy41IiB3aWR0aD0iNTkiIGhlaWdodD0iNzYiIHJ4PSI0LjUiIHN0cm9rZT0iIzEyQjg4NiIgc3Ryb2tlLXdpZHRoPSIzIi8+PHBhdGggc3Ryb2tlPSIjNDE1NUJDIiBzdHJva2Utd2lkdGg9IjMiIGQ9Ik0zMyA0Mi41aDM0TTMzIDUxLjVoMzRNMzMgNjAuNWgzNE0zMyA2OS41aDM0TTMzIDc4LjVoMzQiLz48cGF0aCBkPSJNNzAuNDkxIDc3LjA1NGwxNS0xNSAzIDMtMTUgMTVoLTN2LTN6IiBmaWxsPSIjNDE1NUJDIi8+PC9nPjwvc3ZnPgo=";
export { SvgPicWhatIsWill as ReactComponent };